<template>
  <div :id="id"></div>
    <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'light'"
  />
  <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'medium'"
  />
  <img
    src="@/assets/images/pie-chart-bg-dark.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'dark'"
  />
</template>

<script>
import store from "@/store";

import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: "DynamicCircularPieV3",
  props: ["id", "chartData"],
  data() {
      return {
        seriesData: []
      }
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },
  updated() {
   this.seriesData = [];
   this.renderChart();
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart: function () {

      for(let i = this.chartData.length - 1; i >= 0; i--) {
          const feed =  {
                name: this.chartData[i].key,
                y: this.chartData[i].value,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#1B6371"], /// start
                    [1, "#AEF1FE"], // end
                  ],
                },
                dataLabels: {
                  connectorColor: this.theme=='light' || this.theme=='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 30,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium' ? 
                    `<div class='cust-chart-datalabel' style='white-space:normal;position:relative;color:#527A7A !important;'>${this.chartData[i].key} <span class="${(i == this.chartData.length-1 ) ? 'cust-label': 'cust-label left' }" style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.chartData[i].value}</span></div>` :
                    `<div class='cust-chart-datalabel' style='white-space:normal;position:relative;color:#1B6371 !important;'>${this.chartData[i].key} <span class="${(i == this.chartData.length-1 )  ? 'cust-label': 'cust-label left' }" style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.chartData[i].value}</span></div>`
                    ,
                },
                events: {
                    click: () => {
                        store.dispatch('setFilteredProjects',store.getters.getProjects.filter((item) => item.ProjectSector == this.chartData[i].key));
                        store.dispatch('setActiveFilter',this.chartData[i].key);
                        window.scrollTo({
                            top: document.getElementById('databased-row').offsetTop,
                            behavior: 'smooth'
                        });

                    }
                }
              };
            this.seriesData.push(feed);
      }


      
      Highcharts.chart(this.id, {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: "250px",
        },
        title: null,
        yAxis: [
          {
            min: 0,
            max: 10,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickPixelInterval: 200,
            labels: {
              y: -17,
              distance: 10,
              style: { fontSize: "0.4rem", color: "#41C9BB" },
            },
            title: {
              text: "Score",
              style: { color: "#859392", fontSize: "0.7rem" },
              y: 90,
            },
          },
          {
            linkedTo: 0,
            offset: -27,
            tickInterval: 0.4,
            tickLength: 2,
            tickColor: "#297971",
            tickWidth: 2,
            minorTickInterval: null,
            lineWidth: 0,
            labels: { enabled: !1 },
          },
        ],
        plotOptions: {
          pie: {
            borderWidth: 4,
            borderColor: this.theme == 'light' || this.theme == 'medium'? "#fff" : "#071D1D",
            center: ["50%", "50%"],
            allowPointSelect: true,
            cursor: "pointer",
            size: "60%",
            slicedOffset: 0,
            color: "red",
            fillColor: "red",
            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>",
              connectorColor: "silver",
              color: "#4a7780",
            },
          },
        },
        tooltip: {
          enabled: false,
          formatter: function () {
            return "<b>" + this.point.name + "</b>: " + this.y + " %";
          },
        },
        series: [
          {
            animation: {
              duration: 1500
            },
            data: this.seriesData,
            size: "65%",
            innerSize: "75%",
            showInLegend: false,
            dataLabels: {
              enabled: true,
            },
          },
        ],
      });
      document
      .querySelectorAll(".highcharts-credits")
      .forEach((item) => (item.style.display = "none"));
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
body.theme-light {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
body.theme-medium {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
body.theme-dark {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;
  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
</style>